class ProductDetailSelection
{
    nbAdults: number = 0;
    nbChildren: number = 0;
    classCode: number = 0;
    categoryCode: number = 0;
}

export default ProductDetailSelection;